










import { Vue, Component, Prop } from 'vue-property-decorator';

import IconRemove from '@/components/icons/Remove.vue';

import { Notification } from './types';

@Component({
    components: {
        IconRemove,
    }
})
export default class NotificationMessage extends Vue {
    @Prop({ required: true }) notification!: Notification;

    dismiss() {
        this.$emit('remove')
    }
}
